import jsPDF from "jspdf";
import { formatCurrency } from "./api";
import { getProfession, cap, singularProc } from "./professions";

export function buildQuotePdf(quote, logo, fallbackClinic) {
  const prof = getProfession(quote.profession);
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const marginX = 48;
  let y = 60;

  if (logo) {
    const maxW = 140, maxH = 50;
    const ratio = Math.min(maxW / logo.width, maxH / logo.height);
    const w = logo.width * ratio, h = logo.height * ratio;
    doc.addImage(logo.dataUrl, "PNG", 595 - marginX - w, y - 40, w, h);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(quote.clinic_name || fallbackClinic || cap(`Minha ${prof.place}`), marginX, y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`ORÇAMENTO · ${prof.tagline.replace("Precificação para ", "").toUpperCase()}`, marginX, y + 16);
  doc.text(`Nº ${quote.quote_number}`, marginX, y + 30);
  doc.text(`Data: ${new Date(quote.created_at).toLocaleDateString("pt-BR")}`, marginX, y + 44);

  y += 80;
  doc.setDrawColor(220);
  doc.line(marginX, y, 595 - marginX, y);
  y += 20;

  doc.setTextColor(20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(cap(prof.client), marginX, y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  y += 15;
  doc.text(quote.patient.name, marginX, y);
  if (quote.patient.phone) { y += 13; doc.text(`Tel: ${quote.patient.phone}`, marginX, y); }
  if (quote.patient.email) { y += 13; doc.text(quote.patient.email, marginX, y); }

  y += 30;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(singularProc(prof).toUpperCase(), marginX, y);
  doc.text("QTD", 380, y);
  doc.text("UNITÁRIO", 430, y);
  doc.text("TOTAL", 510, y);
  y += 6;
  doc.line(marginX, y, 595 - marginX, y);
  y += 14;

  doc.setFont("helvetica", "normal");
  quote.items.forEach((it) => {
    doc.text(it.name.substring(0, 50), marginX, y);
    doc.text(String(it.quantity), 380, y);
    doc.text(formatCurrency(it.unit_price), 430, y);
    doc.text(formatCurrency(it.line_total), 510, y);
    y += 18;
  });

  y += 10;
  doc.line(marginX, y, 595 - marginX, y);
  y += 20;
  doc.text("Subtotal:", 430, y);
  doc.text(formatCurrency(quote.subtotal), 510, y);
  if (quote.discount_amount > 0) {
    y += 16;
    doc.text(`Desconto (${quote.discount_percentage}%):`, 430, y);
    doc.text(`- ${formatCurrency(quote.discount_amount)}`, 510, y);
  }
  y += 20;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text("TOTAL:", 430, y);
  doc.text(formatCurrency(quote.total), 510, y);
  if (quote.payment_method) {
    y += 16;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Forma de pagamento: ${quote.payment_method}`, 430, y, { align: "right", maxWidth: 160 });
  }

  if (quote.payment_options?.length) {
    y += 30;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Opções de pagamento:", marginX, y);
    doc.setFont("helvetica", "normal");
    quote.payment_options.forEach((o) => {
      y += 14;
      const v = o.installments ? `${o.installments}x de ${formatCurrency(o.installment_value)} (${formatCurrency(o.total)})` : formatCurrency(o.total);
      doc.text(`${o.name}: ${v}`, marginX + 12, y);
    });
  }

  if (quote.notes) {
    y += 36;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Observações:", marginX, y);
    y += 14;
    doc.setFont("helvetica", "normal");
    const lines = doc.splitTextToSize(quote.notes, 500);
    doc.text(lines, marginX, y);
  }

  doc.save(`orcamento-${quote.quote_number}.pdf`);
}
